export function getFieldErrorNames(
  formikErrors: object,
  prefix: string = '',
  result: string[] = [],
) {
  Object.keys(formikErrors).forEach((key) => {
    const value = formikErrors[key]
    if (!value) return

    const nextKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === 'object') {
      return getFieldErrorNames(value, nextKey, result)
    } else {
      result.push(nextKey)
    }
  })

  return result
}
